export enum CardFormVersion {
  "BEPAID",
  "LEGACY"
}
